import { Button, Col } from "react-bootstrap";
import { z } from "zod";
import { User } from "../../models";
import { Input, StatefulForm, useStatefulForm } from "../../component-library";
import { useToasts } from "../../contexts";
import { useProfileQuery } from "../../queries";
import { useMemo } from "react";

const schema = z.object({
    emailAddress: z.string().email("Invalid email"),
    newEmail: z.string().email("Invalid email"),
});

type EmailFormValues = z.infer<typeof schema>;

type UpdateEmailFormProps = {
    user: User;
};

export const UpdateEmailForm = ({ user: { emailAddress } }: UpdateEmailFormProps) => {
    const { errorToast } = useToasts();
    const { updateEmailMutation } = useProfileQuery();

    const onSubmit = async ({ newEmail }: EmailFormValues) => {
        try {
            await updateEmailMutation.mutateAsync(newEmail);
        } catch (error) {
            errorToast(error);
        }
    };

    const defaultValues = useMemo(() => ({ emailAddress, newEmail: "" }), [emailAddress]);

    const { methods, isDirty } = useStatefulForm({ defaultValues, schema });

    return (
        <StatefulForm onSubmit={(values) => onSubmit(values as EmailFormValues)} methods={methods}>
            <Col className="d-flex flex-column">
                <Input accessor="emailAddress" label="Current Email" disabled />
                <Input accessor="newEmail" label="New Email" type="email" />
                <Button type="submit" className="align-self-center" disabled={!isDirty}>
                    Submit
                </Button>
            </Col>
        </StatefulForm>
    );
};
